import { useEffect, useRef } from 'react';
import { useMap } from '@vis.gl/react-google-maps';
import { ICarbonIntensity } from '../../../../domain/carbon-intensity/interface';
import { calculateCO2IntensityStyle } from './formatMapStyle';
import { REGIONS } from './regions';
import zonesData from './usaZones.json';

export const useUpdateGoogleMapStyles = (carbonIntensity: ICarbonIntensity[], showCarbonIntensityMap: boolean) => {
    const map = useMap();
    const carbonIntensityMap = useRef(new Map<string, number>());
    const geoJsonLoaded = useRef(false);

    useEffect(() => {
        if (!map) return;

        if (carbonIntensity.length && showCarbonIntensityMap) {
            carbonIntensity.forEach((intensity: ICarbonIntensity) => {
                carbonIntensityMap.current.set(intensity.market, intensity.carbonIntensity);
            });

            if (!geoJsonLoaded.current) {
                map.data.addGeoJson(zonesData);
                geoJsonLoaded.current = true;
            }

            map.data.setStyle(item => {
                const zoneName = item.getProperty('zoneName') as string;
                const correspondRegion = REGIONS[zoneName] || '';
                const regionCarbonIntensity = carbonIntensityMap.current.get(correspondRegion.toLowerCase());

                return {
                    fillColor: calculateCO2IntensityStyle(regionCarbonIntensity),
                    fillOpacity: 0.4,
                    strokeWeight: 0.5,
                    strokeColor: '#A9A9A9',
                    strokeOpacity: 0.4,
                };
            });
        } else if (geoJsonLoaded.current) {
            const toRemove: google.maps.Data.Feature[] = [];
            map.data.forEach(feature => toRemove.push(feature));
            toRemove.forEach(feature => map.data.remove(feature));
            geoJsonLoaded.current = false;
        }
    }, [map, carbonIntensity, showCarbonIntensityMap]);
};
